import QrCodeDonwloader from "./QrCodeDonwloader";
export default QrCodeDonwloader;
